module.exports = __webpack_public_path__ + "static/MOD4-3b50b049e2bfce56e43c10b7a36be248.jpg";